import { render, staticRenderFns } from "./cadracaspet.vue?vue&type=template&id=706f5919&"
import script from "./cadracaspet.vue?vue&type=script&lang=js&"
export * from "./cadracaspet.vue?vue&type=script&lang=js&"
import style0 from "./cadracaspet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports